import { useState, useEffect } from "react";
import { saveTicketTimeCard, getTicketLogs } from "../Api/TicketTimeCard";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import Dashboard from "../Components/Dashboard";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const TicketTimeCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchingTicketLogs, setFetchingTicketLogs] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [ticketLogs, setTicketLogs] = useState([]);
  const [timeCardData, setTimeCardData] = useState({
    UserName: "",
    LogId: "", // Hidden field for storing logId
    DisplayTask: "", // For displaying taskOriId - taskName
    Date: "",
    ProjectCode: "",
    Hours: "",
    Tasks: "", // This will store taskOriId - taskName
    Remarks: "",
    Location: ""
  });

  const dropdownOptions = {
    locations: [
      { value: "Work from Home", label: "01 - Work from Home" },
      { value: "Work from Office", label: "02 - Work from Office" },
      { value: "Work from Client", label: "03 - Work from Client" }
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch user data
        const username = localStorage.getItem("username");
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        
        if (!username || !userDetails) {
          toast.error("User session expired. Please login again.");
          navigate("/");
          return;
        }

        // Set initial form data
        setTimeCardData(prev => ({
          ...prev,
          UserName: username
        }));
        
      } catch (error) {
        console.error("Error loading data:", error);
        toast.error("Failed to load data");
      } finally {
        setInitialLoad(false);
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    const fetchTicketLogs = async () => {
      if (!timeCardData.Date) {
        setTicketLogs([]);
        return;
      }

      try {
        setFetchingTicketLogs(true);
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (!userDetails?.email) {
          toast.error("User email not found");
          return;
        }

        const logsData = await getTicketLogs(userDetails.email, timeCardData.Date);
        setTicketLogs(logsData);
        
        if (logsData.length === 0) {
          toast.info("No tasks found for the selected date");
        }
      } catch (error) {
        console.error("Error fetching ticket logs:", error);
        toast.error(error.message || "Failed to load tasks");
        setTicketLogs([]);
      } finally {
        setFetchingTicketLogs(false);
      }
    };

    const timer = setTimeout(() => {
      fetchTicketLogs();
    }, 500);

    return () => clearTimeout(timer);
  }, [timeCardData.Date]);

  const handleTaskSelection = (e) => {
    const selectedIndex = e.target.selectedIndex;
    const selectedLog = ticketLogs[selectedIndex - 1]; // -1 to account for the default option
    
    setTimeCardData(prev => ({
      ...prev,
      LogId: selectedLog?.logId || "", // Store logId (hidden)
      DisplayTask: selectedLog ? `${selectedLog.taskOriId} - ${selectedLog.taskName}` : "",
      ProjectCode: selectedLog?.selectProject || "",
      Tasks: selectedLog ? `${selectedLog.taskOriId} - ${selectedLog.taskName}` : ""
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeCardData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!timeCardData.Date) {
      toast.error("Please select a date");
      return;
    }

    if (timeCardData.Hours <= 0 || timeCardData.Hours > 24) {
      toast.error("Please enter valid hours (0-24)");
      return;
    }

    if (!timeCardData.LogId) {
      toast.error("Please select a task");
      return;
    }

    setLoading(true);
    try {
      await saveTicketTimeCard(timeCardData, timeCardData.UserName);
      toast.success("Ticket Time Card submitted successfully!");
      
      // Reset form except UserName
      setTimeCardData(prev => ({
        ...prev,
        Date: "",
        LogId: "",
        DisplayTask: "",
        ProjectCode: "",
        Hours: "",
        Tasks: "",
        Remarks: "",
        Location: ""
      }));
      setTicketLogs([]);
      
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to submit time card");
    } finally {
      setLoading(false);
    }
  };

  if (initialLoad) {
    return (
      // <Dashboard>
        <div className="main-content expand">
          <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <Sample14 />
          </Container>
        </div>
      // </Dashboard>
    );
  }

  return (
    <>
      {/* <Dashboard> */}
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Ticket Time Card</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>User Name <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="UserName"
                      value={timeCardData.UserName}
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="Date"
                      value={timeCardData.Date}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split('T')[0]} 
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Task <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="DisplayTask"
                      value={timeCardData.DisplayTask}
                      onChange={handleTaskSelection}
                      required
                      disabled={!timeCardData.Date || fetchingTicketLogs}
                    >
                      <option value="">
                        {fetchingTicketLogs ? "Loading tasks..." : 
                         !timeCardData.Date ? "Select date first" : 
                         ticketLogs.length === 0 ? "No tasks found" : "Select Task"}
                      </option>
                      {ticketLogs.map((log) => (
                        <option key={log.logId} value={`${log.taskOriId} - ${log.taskName}`}>
                          {`${log.taskOriId} - ${log.taskName}`}
                        </option>
                      ))}
                    </Form.Select>
                    {fetchingTicketLogs && (
                      <div className="mt-2 text-muted">Fetching tasks...</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="ProjectCode"
                      value={timeCardData.ProjectCode}
                      onChange={handleChange}
                      required
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Task Details <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="Tasks"
                      value={timeCardData.Tasks}
                      onChange={handleChange}
                      required
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hours <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="Hours"
                      value={timeCardData.Hours}
                      onChange={handleChange}
                      required
                      step="1"
                      min="1"
                      max="24"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={1}
                      name="Remarks"
                      value={timeCardData.Remarks}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Location <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="Location"
                      value={timeCardData.Location}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Location</option>
                      {dropdownOptions.locations.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container mt-4">
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="fields-submit"
                  disabled={loading || fetchingTicketLogs}
                >
                  {loading ? "Submitting..." : "Submit Time Card"}
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      {/* </Dashboard> */}

      {(loading || fetchingTicketLogs) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TicketTimeCard;

/* import { useState, useEffect } from "react";
import { saveTicketTimeCard, getTicketLogs } from "../Api/TicketTimeCard";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import Dashboard from "../Components/Dashboard";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const TicketTimeCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fetchingTicketLogs, setFetchingTicketLogs] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [ticketLogs, setTicketLogs] = useState([]);
  const [timeCardData, setTimeCardData] = useState({
    UserName: "",
    TicketId: "", // This will store only the taskOriId
    Date: "",
    ProjectCode: "",
    Hours: "",
    Tasks: "",
    Remarks: "",
    Location: ""
  });

  const dropdownOptions = {
    locations: [
      { value: "01", label: "01 - Work from Home" },
      { value: "02", label: "02 - Work from Office" },
      { value: "03", label: "03 - Work from Client" }
    ]
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch user data
        const username = localStorage.getItem("username");
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        
        if (!username || !userDetails) {
          toast.error("User session expired. Please login again.");
          navigate("/");
          return;
        }

        // Set initial form data
        setTimeCardData(prev => ({
          ...prev,
          UserName: username
        }));
        
      } catch (error) {
        console.error("Error loading data:", error);
        toast.error("Failed to load data");
      } finally {
        setInitialLoad(false);
      }
    };

    fetchData();
  }, [navigate]);

  useEffect(() => {
    const fetchTicketLogs = async () => {
      if (!timeCardData.Date) {
        setTicketLogs([]);
        return;
      }

      try {
        setFetchingTicketLogs(true);
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        if (!userDetails?.email) {
          toast.error("User email not found");
          return;
        }

        const logsData = await getTicketLogs(userDetails.email, timeCardData.Date);
        setTicketLogs(logsData);
        
        if (logsData.length === 0) {
          toast.info("No ticket logs found for the selected date");
        }
      } catch (error) {
        console.error("Error fetching ticket logs:", error);
        toast.error(error.message || "Failed to load ticket logs");
        setTicketLogs([]);
      } finally {
        setFetchingTicketLogs(false);
      }
    };

    const timer = setTimeout(() => {
      fetchTicketLogs();
    }, 500);

    return () => clearTimeout(timer);
  }, [timeCardData.Date]);

  const handleTicketIdChange = (e) => {
    const selectedTaskOriId = e.target.value;
    const selectedLog = ticketLogs.find(log => log.taskOriId === selectedTaskOriId);
    
    setTimeCardData(prev => ({
      ...prev,
      TicketId: selectedTaskOriId, // Store only the taskOriId
      ProjectCode: selectedLog?.selectProject || "",
      Tasks: selectedLog ? `${selectedLog.taskOriId} - ${selectedLog.taskName}` : ""
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeCardData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!timeCardData.Date) {
      toast.error("Please select a date");
      return;
    }

    if (timeCardData.Hours <= 0 || timeCardData.Hours > 24) {
      toast.error("Please enter valid hours (0-24)");
      return;
    }

    if (!timeCardData.TicketId) {
      toast.error("Please select Task ID");
      return;
    }

    setLoading(true);
    try {
      await saveTicketTimeCard(timeCardData, timeCardData.UserName);
      toast.success("Ticket Time Card submitted successfully!");
      
      // Reset form except UserName
      setTimeCardData(prev => ({
        ...prev,
        Date: "",
        TicketId: "",
        ProjectCode: "",
        Hours: "",
        Tasks: "",
        Remarks: "",
        Location: ""
      }));
      setTicketLogs([]);
      
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to submit time card");
    } finally {
      setLoading(false);
    }
  };

  if (initialLoad) {
    return (
      <Dashboard>
        <div className="main-content expand">
          <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <Sample14 />
          </Container>
        </div>
      </Dashboard>
    );
  }

  return (
    <>
      <Dashboard>
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Ticket Time Card</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>User Name <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="UserName"
                      value={timeCardData.UserName}
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="Date"
                      value={timeCardData.Date}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split('T')[0]} 
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Task ID <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="TicketId"
                      value={timeCardData.TicketId}
                      onChange={handleTicketIdChange}
                      required
                      disabled={!timeCardData.Date || fetchingTicketLogs}
                    >
                      <option value="">
                        {fetchingTicketLogs ? "Loading tasks..." : 
                         !timeCardData.Date ? "Select date first" : 
                         ticketLogs.length === 0 ? "No tasks found" : "Select Task"}
                      </option>
                      {ticketLogs.map((log) => (
                        <option key={log.taskOriId} value={log.taskOriId}>
                          {`${log.taskOriId} - ${log.taskName}`}
                        </option>
                      ))}
                    </Form.Select>
                    {fetchingTicketLogs && (
                      <div className="mt-2 text-muted">Fetching tasks...</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="ProjectCode"
                      value={timeCardData.ProjectCode}
                      onChange={handleChange}
                      required
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Task <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="Tasks"
                      value={timeCardData.Tasks}
                      onChange={handleChange}
                      required
                      readOnly
                      className="read-only-field bg-light"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hours <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="Hours"
                      value={timeCardData.Hours}
                      onChange={handleChange}
                      required
                      step="1"
                      min="1"
                      max="24"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks <span className="text-danger">**</span></Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={1}
                      name="Remarks"
                      value={timeCardData.Remarks}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Location <span className="text-danger">**</span></Form.Label>
                    <Form.Select
                      name="Location"
                      value={timeCardData.Location}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Location</option>
                      {dropdownOptions.locations.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container mt-4">
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="fields-submit"
                  disabled={loading || fetchingTicketLogs}
                >
                  {loading ? "Submitting..." : "Submit Time Card"}
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      </Dashboard>

      {(loading || fetchingTicketLogs) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TicketTimeCard; */
